import AnimCounter from "./Animation/AnimCounter";
import AnimGirl from "./Animation/AnimGirl";
import AnimSpace from "./Animation/AnimSpace";
import Button from "./UI/Button/Button";

const MainBlock = () => {
	return (
		<section className="page-main__main-block main-block">
			<div className="main-block__wrapper">
				<p className="main-block__prev">From the company ElSmart</p>
				<h1 className="main-block__title">
					All-Nation competition
					<br />
					Children's drawing
				</h1>
				<p className="main-block__text">
					Participate in the competition and get prizes in various
					<br /> categories of children's drawings for all ages
				</p>

				<div className="main-block__inner">
					<Button
						onClick={(e: any) => e.preventDefault()}
						className="main-block__button"
					>
						Participate
					</Button>

					<AnimCounter />
				</div>
			</div>

			<div className="main-block__image space">
				<AnimSpace />
				<AnimGirl />
			</div>
		</section>
	);
};

export default MainBlock;
